// these are extensions for tailwindcss
// see tailwindcss.com
// if you are unfamiliar with tailwind do not add themes here because
// they could override existing tailwind classes
// add themes to the theme file

const dashboardTailwindExtensions = {
  fontSize: {
    xxs: '.625rem',
    md: '1rem',
  },
  fontFamily: {
    title: ['Gilroy', 'sans-serif'],
    body: ['Gilroy', 'sans-serif'],
  },
  colors: {
    'green-primary': '#26E3BA',
    'black-primary': '#011516',
    'black-secondary': '#030E0E',
    'off-white': '#FCFCFC',
    background: '#FAFAFA',
    'gray-primary': '#7aa4a7',
    'gray-secondary': '#D8D8D8',
    'support': '#152D2D',
    'critical': '#FF8080'
  },
  boxShadow: {
    container: '0 2px 4px 0 rgba(156, 166, 199, 0.18)',
    header: '0 2px 34px 0 rgba(48,156,133,0.08)',
    button: '1px 9px 20px -5px rgba(30,61,63,0.26)',
    'button-green': '0 9px 20px -5px rgba(48, 156, 133, .29)',
  },
};

const screens = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1180px',
};

module.exports = { dashboardTailwindExtensions, screens };
